export enum NumerationType {
    BUDGETS = 'BUDGETS',
}
